<div
	class="w-full text-center"
	*ngIf="!orderValid && !invalidProperty && !outOfOntario"
>
	<p class="text-2xl font-bold">Collect information</p>
	<p class="mt-2 text-base text-gray-600">
		Please add information to the identified missing fields in Closer.
	</p>
</div>

<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight px-10 py-5 mt-5 item-center justify-center mb-5"
>
	<div
		*ngIf="invalidProperty"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property type not supported</p>
		<p class="mx-5 text-sm text-center w-2/3" *ngIf="invalidProperty">
			The property type you've selected is not supported. Please select a new
			property type to continue.
		</p>
	</div>
	<div
		*ngIf="!invalidProperty && outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property location not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Policies for properties outside of Ontario are not supported. Please
			select a different property.
		</p>
	</div>
	<div
		*ngIf="orderValid"
		class="flex flex-col items-center justify-center px-10 gap-5 pb-10"
	>
		<app-icon [icon]="ICON.CHECK" class="text-green text-4xl"></app-icon>
		<p *ngIf="!isCommercial" class="text-xl">Ready to begin order!</p>
		<p *ngIf="isCommercial" class="text-xl font-bold text-gray-600">
			All information collected
		</p>
		<p>You've collected everything you need to begin your order with FCT</p>
	</div>
	<div
		*ngIf="!orderValid && !invalidProperty && !outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-2"
	>
		<app-icon class="text-orange text-2xl" [icon]="ICON.WARNING"></app-icon>
		<p class="mx-5 text-center">You have the following missing information</p>
		<div class="flex flex-col flex-1 justify-center px-10 w-96">
			<div
				class="items-center text-center"
				*ngFor="let fieldSection of missing"
			>
				<p class="mb-1 mt-5 font-bold">{{ fieldSection.sectionName }}</p>
				<div
					*ngFor="let field of fieldSection.fields"
					class="flex mt-2 items-center justify-center text-center"
				>
					<app-icon [icon]="ICON.ERROR" class="text-red mr-3"></app-icon>
					<app-anchor
						*ngIf="field.fieldName !== 'Closing date'"
						[url]="field.url"
						[queryParams]="backUrlParams"
						type="static"
						[testHook]="testHooks.Link"
						>{{ field.fieldName }}</app-anchor
					>
					<button
						*ngIf="field.fieldName === 'Closing date'"
						type="button"
						(click)="openKeyDatesDrawer($event)"
						class="text-green-600 underline"
						[testHook]="testHooks.OpenKeyDatesDrawerButton"
					>
						{{ field.fieldName }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<div
		*ngIf="!isCommercial"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-button
			*ngIf="orderValid"
			[icon]="ICON.EXTERNAL"
			[disabled]="!orderValid"
			(click)="_openModal()"
			[testHook]="testHooks.StartOrderButton"
			>Start order</app-button
		>
		<app-button *ngIf="invalidProperty" [testHook]="testHooks.Button"
			><app-anchor
				[cssClasses]="['text-green']"
				[icon]="ICON.EDIT"
				[url]="propertyUrl"
				[queryParams]="backUrlParams"
				[testHook]="testHooks.ChangePropertyTypeLink"
				>Change property type</app-anchor
			></app-button
		>
		<app-button
			*ngIf="!invalidProperty && outOfOntario"
			[testHook]="testHooks.Button1"
			><app-anchor
				[cssClasses]="['text-green']"
				[icon]="ICON.EDIT"
				[url]="propertyUrl"
				[queryParams]="backUrlParams"
				[testHook]="testHooks.ChangePropertyAddressLink"
				>Change property address</app-anchor
			></app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-fct-footer
			(openModal)="_openModal()"
			(cancelOrder)="cancel()"
		></app-fct-footer>
	</div>
</div>
